import { Base } from "../../framework/base";
import { EnumHelper } from "../enums";
import { Translations } from "../translations";
import { IUserGroupListItemUser, UserGroupListItemUser } from "./userGroupListItemUser";

export interface IUserGroupListItem {
    id: string;
    companyCode: string;
    code: string;
    name: string;
    comment: string;
    picture: string;
    level: number;
    qrCodeUserGroup: boolean;
    users: IUserGroupListItemUser[];

    levelStr: string;
    getTitle(): string;
}

export class UserGroupListItem implements IUserGroupListItem {
    id: string;
    companyCode: string;
    code: string;
    name: string;
    comment: string;
    picture: string;
    level: number;
    qrCodeUserGroup: boolean;
    users: UserGroupListItemUser[];
    
    levelStr: string;

    constructor();
    constructor(obj: IUserGroupListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.companyCode = obj && obj.companyCode || "";
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.comment = obj && obj.comment || "";
        this.picture = obj && obj.picture || "";
        this.level = obj && obj.level || 0;
        this.qrCodeUserGroup = obj && obj.qrCodeUserGroup || false;
        this.levelStr = !this.qrCodeUserGroup
            ? EnumHelper.UserGroupAuthorizationLevelToStr(this.level)
            : Translations.AuthorizationLevelQrCodeUser;
        this.users = Base.getTypedArray(obj ? obj.users : null, UserGroupListItemUser);
    }

    getTitle(): string {
        return this.name;
    }
    
    static sortUserGroupListItems(items: IUserGroupListItem[], column: string, asc: boolean): IUserGroupListItem[] {
        if (!items && items.length < 2) return items;
        if (column === "name") {
            return items.sort((a: IUserGroupListItem, b: IUserGroupListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.name, b.name)); });
        } else if (column === "comment") {
            return items.sort((a: IUserGroupListItem, b: IUserGroupListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.comment, b.comment)); });
        } else {
            return items.sort((a: IUserGroupListItem, b: IUserGroupListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.level, b.level)); });
        }
    }
}